import { Box, Typography } from "@mui/material";

type StatusBarProps = {
  status: 'ACTIVE' | "PASSIVE" | "BLOCKED" | string;
};

export const StatusBar = ({status}: StatusBarProps) => {

  let bgColor;
  let borderColor;
  let textColor;
  let text;

  switch(status) {
    case 'ACTIVE':
      bgColor = "success.extraLighter";
      borderColor = "#00B0A6";
      textColor = "success.main";
      text = 'Aktif';
      break;

    case 'BLOCKED':
      bgColor = "error.extraLighter";
      borderColor = "#ff0000"; 
      textColor = "error.main"; 
      text = 'Bloke';
      break;

    default: 
      bgColor = "warning.extraLighter";
      borderColor = "#ffb800";
      textColor = "warning.main";
      text = 'Pasif';
      break;
  }

  return (
    <Box sx={{textAlign: 'center', width: 60, borderRadius: 2, backgroundColor: bgColor, border: `1px solid ${borderColor}`}}>
      <Typography variant="overline" color={textColor}>{text}</Typography>
    </Box>
  );
}